import { useTranslation } from 'react-i18next';

import { Icon } from '@/shared/ui/icon';

/** Poloprůhledný overlay přes tabulku během načítání (anatomie 03 §7). */
export function LoadingOverlay() {
  const { t } = useTranslation('listPage');
  return (
    <div className="phxlist-loading">
      <div className="phxlist-loading-card">
        <span className="phxlist-spin text-phx-primary">
          <Icon name="refresh" size={15} />
        </span>
        <span>{t('states.loading')}</span>
      </div>
    </div>
  );
}

/** Prázdný výsledek — titulek + doporučení upravit filtry, bez ilustrací (anatomie 03 §7). */
export function EmptyResult() {
  const { t } = useTranslation('listPage');
  return (
    <div className="text-phx-text-faint py-phx-11 text-center">
      <div className="mb-phx-3 flex justify-center opacity-60">
        <Icon name="search" size={22} />
      </div>
      <div className="text-phx-lg text-phx-text-2 font-semibold">{t('states.emptyTitle')}</div>
      <div className="text-phx-sm mt-phx-1">{t('states.emptyHint')}</div>
    </div>
  );
}

/** Stav „čeká na vyhledání" (anatomie 04 §3) — agenda bez automatického načtení. */
export function WaitingForSearch({
  onSearch,
  loading,
}: {
  onSearch: () => void;
  loading: boolean;
}) {
  const { t } = useTranslation('listPage');
  return (
    <div className="phxlist-waiting">
      <div className="phxlist-waiting-ico">
        <Icon name="search" size={24} />
      </div>
      <div className="text-phx-text text-[15px] font-semibold">{t('states.waitingTitle')}</div>
      <div className="text-phx-sm max-w-[430px] leading-relaxed">{t('states.waitingHint')}</div>
      <button
        type="button"
        className="phxlist-btn mt-phx-2"
        data-variant="primary"
        disabled={loading}
        onClick={onSearch}
      >
        <span className={loading ? 'phxlist-spin' : undefined}>
          <Icon name={loading ? 'refresh' : 'search'} size={13} />
        </span>
        {t('toolbar.search')}
      </button>
    </div>
  );
}

/** Chyba načtení — popisuje chybu, ne osobu; nabízí opakování (anatomie 04 §4). */
export function LoadError({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation('listPage');
  return (
    <div className="text-phx-text-muted py-phx-11 text-center">
      <div className="mb-phx-3 text-phx-danger flex justify-center">
        <Icon name="alert" size={22} />
      </div>
      <div className="text-phx-lg text-phx-text font-semibold">{t('states.errorTitle')}</div>
      <div className="text-phx-sm mt-phx-1">{t('states.errorHint')}</div>
      <button type="button" className="phxlist-btn mt-phx-4" onClick={onRetry}>
        <Icon name="refresh" size={13} />
        {t('states.retry')}
      </button>
    </div>
  );
}
